import { useScreenSize } from '@/hooks';
import type { SVGProps } from 'react';

type Props = Omit<SVGProps<SVGSVGElement>, 'width' | 'height'> & {
    width?: number;
    height?: number;
};

export const RouteIcon = ({ stroke = 'currentColor',  width = 80, height = 80, ...props }: Props) => {
    const { scaleWidthPixel, scaleHeightPixel } = useScreenSize();
    return (
        <svg width={scaleWidthPixel(width)} height={scaleHeightPixel(height)} viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M3.76368 7.01855H17.8398C20.0688 7.01855 21.8758 8.82553 21.8758 11.0545C21.8758 13.2836 20.0688 15.0905 17.8398 15.0905H11.3741C9.14958 15.0905 7.34626 16.8938 7.34626 19.1183C7.34626 21.3428 9.14958 23.1462 11.3741 23.1462H16.3859"
                stroke={stroke}
                stroke-width="2"
            />
            <ellipse cx="21.8764" cy="23.1459" rx="2.6498" ry="2.6498" stroke={stroke} stroke-width="2" />
            <path d="M7.08235 3L3 7.08235L7.08235 11.1647" stroke={stroke} stroke-width="1.75" />
        </svg>
    );
};
